import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loading", "disabled", "invalid", "inline", "leftEnhancer", "rightEnhancer", "leftAdornment", "rightAdornment", "inputRef", "size", "onChange", "onFocus", "onBlur", "width", "minWidth", "maxWidth"];
import * as React from 'react';
import { InputWrapper } from '../../../internal/components/InputWrapper';
import * as styles from './styles.css';
var InputComponent = /*#__PURE__*/React.forwardRef(function Input(props, ref) {
  var loading = props.loading,
    disabled = props.disabled,
    invalid = props.invalid,
    inline = props.inline,
    leftEnhancer = props.leftEnhancer,
    rightEnhancer = props.rightEnhancer,
    leftAdornment = props.leftAdornment,
    rightAdornment = props.rightAdornment,
    inputRef = props.inputRef,
    size = props.size,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focused = _React$useState2[0],
    setFocused = _React$useState2[1];
  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e, e.currentTarget.value);
    }
  };
  var handleFocus = function handleFocus(e) {
    setFocused(true);
    if (onFocus) {
      onFocus(e);
    }
  };
  var handleBlur = function handleBlur(e) {
    setFocused(false);
    if (onBlur) {
      onBlur(e);
    }
  };
  return /*#__PURE__*/React.createElement(InputWrapper, {
    ref: ref,
    focused: focused,
    loading: loading,
    disabled: disabled,
    inline: inline,
    invalid: invalid,
    leftEnhancer: leftEnhancer,
    rightEnhancer: rightEnhancer,
    leftAdornment: leftAdornment,
    rightAdornment: rightAdornment,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth
  }, /*#__PURE__*/React.createElement("input", _extends({}, rest, {
    className: styles['input'],
    ref: inputRef,
    disabled: disabled,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  })));
});
InputComponent.defaultProps = {
  type: 'text'
};
export var Input = /*#__PURE__*/React.memo(InputComponent);